import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IContragentBadDelete } from './interfaces';

export const getContragentBadDeleteList = (data: IDynamicTableParams) => {
  return instance()
    .post<IContragentBadDelete[]>('/dictionary/contragentBadDelete/list', data)
    .then((response) => response.data);
};

export const getContragentBadDeleteAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/dictionary/contragentBadDelete/availableColumns')
    .then((response) => response.data);
};

export const getContragentBadDeleteAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/dictionary/contragentBadDelete/availableGroupColumns')
    .then((response) => response.data);
};

export const loadContragentBadDelete = (contragentBadDeleteId: number) => {
  return instance()
    .post<IContragentBadDelete>('/dictionary/contragentBadDelete/load/' + contragentBadDeleteId)
    .then((response) => response.data);
};

export const createContragentBadDelete = (contragentBadDelete: IContragentBadDelete) => {
  return instance()
    .post<IContragentBadDelete>('/dictionary/contragentBadDelete/create', contragentBadDelete)
    .then((response) => response.data);
};

export const updateContragentBadDelete = (contragentBadDeleteId: number, contragentBadDelete: IContragentBadDelete) => {
  return instance()
    .post<IContragentBadDelete>('/dictionary/contragentBadDelete/update/' + contragentBadDeleteId, contragentBadDelete)
    .then((response) => response.data);
};

export const archiveContragentBadDelete = (contragentBadDeleteId: number, isDeleted: boolean) => {
  return instance()
    .post(`/dictionary/contragentBadDelete/deleted/${contragentBadDeleteId}`, { isDeleted })
    .then((response) => response.data);
};
